/**
 * The request-sent page's standard look (approval-web.html Sent B: the booked
 * page's centered shape in the Telegram message's words). Draws the behavior
 * half's state and calls its actions; holds no rule.
 */
import { partsOf, pieceRoot } from '../../contract/runtime';
import shared from '../../styles/shared.module.css';
import { Icon } from '../../ui/Icon';
import { TelegramLine, Ticket } from '../booked/BookedView';
import css from '../booked/Booked.module.css';
import type { RequestSentRuntime } from './useRequestSent';
import { contract } from './contract';

const part = partsOf(contract);

export function RequestSentView({ state, actions }: RequestSentRuntime) {
  if (state.status !== 'ready') return null;
  return (
    <div className={css.c2} {...pieceRoot(contract)} {...part('page')}>
      <div className={css.head}>
        <span className={css.check} aria-hidden="true">
          <Icon name="clock" />
        </span>
        <h1 className={`${css.title} ${css.serif}`} {...part('title')}>
          {state.cancelled ? 'Request cancelled' : 'Request sent'}
        </h1>
        <p className={css.lead} {...part('lead')}>
          {state.lead}
        </p>
      </div>
      <Ticket
        name={state.name}
        photo={state.photo}
        withName={state.withName}
        rows={state.rows}
        calendar={state.cancelled || !state.calendar ? null : { ...state.calendar, download: actions.addToCalendar }}
      />
      {!state.cancelled && (
        <div className={css.actions}>
          <a className={`${shared.btn} ${shared.btnPrimary}`} href={state.bookingHref} {...part('viewBooking')}>
            View my booking
          </a>
        </div>
      )}
      {state.canCancel && (
        <div className={css.cancel}>
          <button type="button" className={css.dangerLink} disabled={state.cancelling} onClick={actions.cancel} {...part('cancel')}>
            Cancel request
          </button>
          {state.problem && (
            <p className={css.problem} role="alert" {...part('problem')}>
              {state.problem}
            </p>
          )}
        </div>
      )}
      <TelegramLine line={state.telegram} />
    </div>
  );
}
